import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/tracking-number';
import { AdvancedSearchShipmentContext } from '../../context';
import messages from '../messages';

const TrackingNumberFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.trackingNumber} updateFilter={updateFilter} />;
};

export default TrackingNumberFilter;
